module.exports = __webpack_public_path__ + "img/28.9257a223.jpg";